import type {
  CrmTaxonomy,
  CrmTaxonomyTag,
} from '@/services/bff/taxonomy-management.api';

export type TagTreeNode = {
  title: string;
  value: string;
  label?: string;
  selectable?: boolean;
  children: TagTreeNode[];
};

function toTagTreeNodes(
  tags: CrmTaxonomyTag[],
  ancestors: string[] = [],
): TagTreeNode[] {
  return tags.map((tag) => ({
    title: tag.name,
    value: tag.uuid,
    label: [...ancestors, tag.name].join(' / '),
    children: toTagTreeNodes(tag.children || [], [...ancestors, tag.name]),
  }));
}

export function buildTagTreeData(
  taxonomies: Array<CrmTaxonomy & { tags: CrmTaxonomyTag[] }>,
): TagTreeNode[] {
  return taxonomies.flatMap((taxonomy) => toTagTreeNodes(taxonomy.tags || []));
}

export function mergeTagUuids(
  current: string[],
  changed: string[],
  operation: 'add' | 'remove',
) {
  const result = new Set(current);
  changed.forEach((uuid) => {
    if (operation === 'add') result.add(uuid);
    else result.delete(uuid);
  });
  return Array.from(result);
}

export function normalizeTagPath(value: string) {
  const path = value.replace(/\s/gu, '');
  const parts = path.split('/');
  const error = parts.some((part) => !part)
    ? '标签路径不能为空或包含空层级'
    : parts.some((part) => part.length > 100)
      ? '每级标签名称须为 1–100 个字符'
      : undefined;
  return { path, error };
}
